module.exports = __webpack_public_path__ + "static/media/MacOS_wordmark.b4ab143b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MacOS_wordmark.svg
// module id = 470
// module chunks = 21